import React from 'react';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink } from 'reactstrap';
import { firebase } from '../utils/firebase';


export default class VerfidNavbar extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.signOut = this.signOut.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.state = {
      isOpen: false,
      displaySignout: false,
    };
  }

  
  componentDidMount() {

    let myApp = this;
    var authValue;
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        authValue = true;
        myApp.setState({displaySignout: authValue})
        // User is signed in.
      } else {
        authValue = false;
        myApp.setState({displaySignout: authValue})
        // No user is signed in.
      }
    });

    /*
    setTimeout(() => {
      var user = firebase.auth().currentUser;
      console.log("component mounting 2")
      console.log(this.state)

      if (user) {
        this.setState({displaySignout: true})
        // User is signed in.
        // Sign-out successful.
      } else {
        this.setState({displaySignout: false})
        // No user is signed in.
      }
    }, 1000);
    */

  }
    
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  signOut(){

    firebase.auth().signOut();
    this.setState({
      isSignedIn: false
    })
  }

  render() {
    return (
      <div>

        <Navbar color="white" light expand="md">
        <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <NavItem>
                <NavLink href="https://verfidpet.com" className="navLinkItem">HOME</NavLink>
              </NavItem>
              
              <NavItem>
                <NavLink href="/" className="navLinkItem">ACCOUNT</NavLink>
              </NavItem>

              <NavItem>
                <NavLink href="/login" className="navLinkItem">PROFILE</NavLink>
              </NavItem>

              <NavItem>
                <NavLink href="/gift" className="navLinkItem">GIFT</NavLink>
              </NavItem>

              <NavItem>
                {
                  this.state.displaySignout?
                <NavLink href="/login" onClick={this.signOut} className="navLinkItem">SIGN OUT</NavLink>
                  :null
                }
                </NavItem>

            </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/navbar.js